import { axios, get, post, put } from './axios';

import { SharedFilterResultTypes } from '../types';
import {
  GET_PRODUCT_BY_SHARE_CODE_API,
  GET_PRODUCT_INVENTORY_API,
  // GET_SESSION_INVENTORY_API,
  GET_PRODUCT_INVENTORY_SHARE_API,
  POST_SHARE_FILTER_RESULT_API,
} from '../commons/constants';
import {
  PageRequest,
  PaginationResponseTypes,
  // ProjectChildItemResponseTypes,
  PropertiesResponseTypes,
  ResponseTypes,
} from '../types/response';

import { PropertiesCriteria } from '../redux/models/properties.model';
// import { SessionCriteria } from '../redux/models/session.model';

export const getInventoryProducts = async (
  request: PropertiesCriteria & PageRequest
): Promise<PaginationResponseTypes<PropertiesResponseTypes[]>> => {
  let res: PaginationResponseTypes<PropertiesResponseTypes[]>;
  try {
    const { projectCode, ...rest } = request;

    res = await get(`${GET_PRODUCT_INVENTORY_API}`, {
      params: { ...rest, projectCodes: projectCode },
    });
  } catch (e) {
    console.error(e);
    return null;
  }
  return res;
};

export const shareFilterResult = async (request: {
  includeCodes: string[];
  projectCodes: string[];
  emails: string[];
  description: string;
  lang: string;
}): Promise<{ data: string }> => {
  const { includeCodes, projectCodes, emails, description, lang } = request;

  return post(POST_SHARE_FILTER_RESULT_API, {
    criteria: { includeCodes, projectCodes },
    emails,
    description,
    lang,
  });
};

export const getBySharedCode = async (
  request: PropertiesCriteria & PageRequest
): Promise<PaginationResponseTypes<PropertiesResponseTypes[]>> => {
  const { code, ...rest } = request;

  let res: PaginationResponseTypes<PropertiesResponseTypes[]>;
  try {
    res = await get(`${GET_PRODUCT_BY_SHARE_CODE_API}/${code}`, {
      params: { ...rest },
    });
  } catch (e) {
    console.error(e);
    return null;
  }
  return res;
};

export const updatePrice = async (
  code: string,
  request: {
    price: number;
  }
): Promise<ResponseTypes<PropertiesResponseTypes>> => {
  return put(`${GET_PRODUCT_INVENTORY_API}/${code}/price`, request);
};

export const updateStatus = async (
  code: string,
  request: {
    status: string;
  }
): Promise<ResponseTypes<PropertiesResponseTypes>> => {
  return put(`${GET_PRODUCT_INVENTORY_API}/${code}/status`, request);
};

export const getSharedFilterResult = async (
  request: PropertiesCriteria & PageRequest
): Promise<PaginationResponseTypes<SharedFilterResultTypes[]>> => {
  let res: PaginationResponseTypes<SharedFilterResultTypes[]>;
  try {
    res = await get(`${GET_PRODUCT_INVENTORY_SHARE_API}`, {
      params: request,
    });
  } catch (e) {
    console.error(e);
    return null;
  }
  return res;
};

export const deleteSharedFilterResult = async (code: string): Promise<boolean> => {
  let res: any;

  try {
    res = await axios.delete(`${GET_PRODUCT_INVENTORY_SHARE_API}/${code}`);
  } catch (e) {
    console.error(e);
    return null;
  }

  return res.data;
};

export const retrySharedFilterResult = async (request: {
  code: string;
  lang: string;
  emails: string[];
}): Promise<boolean> => {
  let res: any;
  const { code, lang, emails } = request;
  try {
    res = await put(`${GET_PRODUCT_INVENTORY_SHARE_API}/${code}/retry`, { lang, emails });
  } catch (e) {
    console.error(e);
    return null;
  }
  return res;
};
